export default "__VITE_ASSET__Y_VN_Skq__"